export const UPDATE_REDUX_WITH_FIRE_DB = "FIREBASE_DATA";

export const updateReduxWithFireDb = data => {
  try {
    return {
      type: UPDATE_REDUX_WITH_FIRE_DB,
      payload: data
    };
  }
  catch(error){
     return {
       type: 'UPDATE_REDUX_WITH_FIRE_DB_FAIL',
       payload: error.message
     }
  }
  
};
